import { Sun } from 'lucide-react'
import { HojeAgenda } from '@/components/hoje/HojeAgenda'
import { HojeFinanceiro } from '@/components/hoje/HojeFinanceiro'
import { HojePrazos } from '@/components/hoje/HojePrazos'
import { HojePublicacoes } from '@/components/hoje/HojePublicacoes'
import { useAuth } from '@/contexts/AuthContext'
import { todayLabel } from '@/lib/hoje'
import { FINANCE_PERMISSION } from '@/lib/navigation'
import { hasPermission } from '@/lib/roles'

/**
 * Hoje: tela de entrada depois do login. Cada bloco carrega da API do seu
 * módulo e leva à visão completa; um bloco que falha não derruba os outros.
 */
export function HojePage() {
  const { user } = useAuth()
  const showFinance = hasPermission(user?.permissions, FINANCE_PERMISSION)

  return (
    <div className="flex flex-col gap-4 p-4 sm:p-6">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Sun className="size-6 text-muted-foreground" />
          <h1 className="text-2xl font-semibold">Hoje</h1>
        </div>
        <p className="text-sm text-muted-foreground first-letter:uppercase">{todayLabel()}</p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <HojePrazos />
        <HojeAgenda />
        <HojePublicacoes />
        {showFinance && <HojeFinanceiro />}
      </div>
    </div>
  )
}
